<template>
  <router-view />
</template>

<script>
export default {
  name: 'TechSupportIndex'
}
</script>

